import React from "react";
import { Typography, Space } from "antd";
import GeneralCard from "@/components/card/GeneralCard";
import "@/styles/pages/common/termsandcondition.scss";
import { Link as RouterLink } from "react-router-dom";

const { Title, Paragraph } = Typography;

const TermsAndCondtion = () => {
  return (
    <div className="terms-and-condtion-wrapper">
      <GeneralCard>
        <div className="terms-and-conditions container">
          <Space direction="vertical" size="medium" className="terms-space">
            <Title level={2} className="center" style={{ marginBottom: "35px" }}>
              Inforens Terms and Conditions
            </Title>
            <Paragraph style={{ marginBottom: "35px" }}>
              Please read these terms and conditions (“terms and conditions”, “terms”) carefully
              before using Inforens (“platform”, “website”, “application”) operated by Inforens
              Global Ltd. (“Inforens”, “us”, “we”, “our”).
            </Paragraph>

            <Title level={4}>Conditions of Use</Title>
            <Paragraph style={{ marginBottom: "35px" }}>
              By using this platform, you certify that you have read and reviewed this Agreement and
              that you agree to comply with its terms. If you do not want to be bound by the terms
              of this Agreement, you are advised to stop using the platform accordingly. Inforens
              only grants use and access of this platform, its products, and its services to those
              who have accepted its terms.
            </Paragraph>

            <Title level={4}>Privacy Policy</Title>
            <Paragraph style={{ marginBottom: "35px" }}>
              Before you continue using our platform, we advise you to read our{" "}
              <RouterLink to="/privacy-policy">privacy policy</RouterLink> regarding our user data
              collection. It will help you better understand our practices which are in line with
              General Data Protection Regulations (GDPR).
            </Paragraph>

            <Title level={4}>Privacy and Protection Clause</Title>
            <Paragraph>
              At Inforens, we are committed to protecting the privacy of all our users. Our
              practices comply with the UK GDPR and the Data Protection Act 2018, ensuring that
              user's personal data is handled with utmost care and responsibility.
            </Paragraph>

            <Paragraph>
              <span style={{ textDecoration: "underline" }}>Data Collection and Use:</span>
              <span style={{ marginLeft: "5px" }}>
                We collect only the necessary personal data from users to provide our services. This
                includes information such as names, email addresses, and educational background. We
                ensure that this data is used solely for the purposes of supporting the services
                related to higher-education needs of our users, and is not shared with third parties
                without explicit consent.
              </span>
            </Paragraph>

            <Paragraph>
              <span style={{ textDecoration: "underline" }}>Data Minimization and Security:</span>
              <span style={{ marginLeft: "5px" }}>
                We implement robust security measures to protect personal data from unauthorized
                access, loss, or misuse. We only collect data that is necessary for the
                functionality of our services and regularly review our data collection practices to
                ensure compliance with data minimization principles.
              </span>
            </Paragraph>

            <Paragraph style={{ fontStyle: "italic", color: "gray" }}>
              <span style={{ fontWeight: 600, color: "black" }}>Children's Privacy:</span>
              <span style={{ marginLeft: "5px" }}>
                Our website, app, and services are not aimed at children. We do not target, intend
                to collect, or knowingly collect or otherwise process information from any Child.
              </span>
              <span>
                Our website, app, and services are not aimed at children. We do not target, intend
                to collect, or knowingly collect or otherwise process information from any Child.
              </span>
              <br />
              <br />
              <span>
                If you are under the age of 18 years, we request that you do not provide us with
                your information and do not use our website and app. If you are a parent or guardian
                of a child under 18 years, please contact us if you are aware that your child has
                used our website or app or otherwise provided their information to us without your
                consent.
              </span>
              <br />
              <br />
              <span>
                We shall erase or otherwise cease processing your child’s personal information
                within a reasonable time to make sure that we do not contact you in the future.
              </span>
            </Paragraph>
            <Paragraph style={{ marginBottom: "35px" }}>
              By continuing to use any services from Inforens, you acknowledge you are over the age
              of 18 years and agree to our practices regarding data privacy and protection.
            </Paragraph>

            <Title level={4}>Intellectual Property</Title>
            <Paragraph>
              You agree that all materials, products, and services provided on this platform
              including all copyrights, trade secrets, trademarks, patents, and other intellectual
              property are the property of Inforens, its affiliates, directors, officers, employees,
              agents, suppliers, or licensors. You also agree that you will not reproduce or
              redistribute Inforens’ intellectual property in any way, including electronic,
              digital, or new trademark registrations.
            </Paragraph>
            <Paragraph style={{ marginBottom: "35px" }}>
              You grant Inforens a royalty-free and non-exclusive license to display, use, copy,
              transmit, and broadcast the content you upload and publish. For issues regarding
              intellectual property claims, you should contact the company in order to come to an
              agreement.
            </Paragraph>

            <Title level={4}>User Accounts</Title>
            <Paragraph>
              As a user of this platform, you may be asked to register with us and provide personal
              information. You are responsible for ensuring the accuracy of this information, and
              you are responsible for maintaining the safety and security of your identifying
              information.
            </Paragraph>
            <Paragraph>
              You are also responsible for all activities that occur under your account or password.
            </Paragraph>
            <Paragraph>
              If you think there are any possible issues regarding the security of your account on
              the platform, inform us immediately so we may address them accordingly.
            </Paragraph>
            <Paragraph style={{ marginBottom: "35px" }}>
              We reserve all rights to terminate accounts, edit or remove content, and cancel orders
              at our sole discretion.
            </Paragraph>

            <Title level={4}>Links to Other Websites</Title>
            <Paragraph>
              Our Services may contain links to third-party web sites or services that are not owned
              or controlled by Inforens.
            </Paragraph>
            <Paragraph>
              Inforens has no control over, and assumes no responsibility for, the content, privacy
              policies, or practices of any third-party web sites or services. You further
              acknowledge and agree that Inforens shall not be responsible or liable, directly or
              indirectly, for any damage or loss caused or alleged to be caused by or in connection
              with the use of or reliance on any such content, goods, or services available on or
              through any such web sites or services.
            </Paragraph>
            <Paragraph style={{ marginBottom: "35px" }}>
              We strongly advise you to read the terms and conditions and privacy policies of any
              third-party web sites or services that you visit.
            </Paragraph>

            <Title level={4}>Refund Policy</Title>

            <Paragraph>
              <span style={{ textDecoration: "underline" }}>Refund Requests:</span>
              <span style={{ marginLeft: "5px" }}>
                If you reconsider your purchase on our platform, please contact our support team
                within 24 hours of the purchase date. We will review your request on a case-by-case
                basis and may offer a partial or full refund at our discretion.
              </span>
            </Paragraph>
            <Paragraph style={{ marginBottom: "35px" }}>
              <span style={{ textDecoration: "underline" }}>Exceptional Circumstances:</span>
              <span style={{ marginLeft: "5px" }}>
                We understand that unforeseen circumstances can arise. If you are unable to use our
                service due to technical issues or other valid reasons, please reach out to our
                support team for assistance. We are committed to resolving any issues promptly and
                fairly.
              </span>
            </Paragraph>

            <Title level={4}>How to Request a Refund:</Title>
            <Paragraph>
              <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
                <li style={{ position: "relative", marginBottom: "5px" }}>
                  To request a refund, please contact our customer support team through the platform
                  or via email at contact@inforens.com
                </li>
                <li style={{ position: "disc", marginLeft: "20px" }}>
                  Provide your order number, date of purchase, and reason for the refund request.
                </li>
              </ul>
            </Paragraph>

            <Title level={5}>a. Processing of Refunds:</Title>
            <Paragraph style={{ marginBottom: "20px" }}>
              <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
                <li>Platform refunds will be processed within 14 days of the refund request.</li>
                <li>
                  Refunds will be issued to the original payment method used for the purchase. Any
                  additional charges levied by the payment portal will be deducted from the refund
                  amount.
                </li>
              </ul>
            </Paragraph>

            <Title level={5}>b. Exceptions:</Title>
            <Paragraph style={{ marginBottom: "35px" }}>
              <ul style={{ listStyleType: "disc", marginLeft: "20px" }}>
                <li>Refunds may not be available for:</li>
                <ul style={{ listStyleType: "none", marginLeft: "10px", paddingLeft: "0" }}>
                  <li style={{ marginBottom: "8px" }}>
                    - Services that have been fully consumed or completed
                  </li>
                  <li style={{ marginBottom: "8px" }}>- Personalized or bespoke services</li>
                  <li style={{ marginBottom: "8px" }}>
                    - Booked online session within the minimum notice period for rescheduling
                  </li>
                  <li style={{ marginBottom: "8px" }}>
                    - Services where you have breached the T&Cs
                  </li>
                </ul>
              </ul>
            </Paragraph>

            <Title level={4}>Rescheduling Policy</Title>
            <Paragraph>
              At Inforens, we understand that plans can change. To accommodate this, we offer a
              flexible rescheduling policy for 1-to-1 online sessions booked and paid for, through
              our online application. Please review the following terms related to rescheduling
              requests:
            </Paragraph>

            <Paragraph>
              <span style={{ textDecoration: "underline" }}>Notice Period:</span>
              <span style={{ marginLeft: "5px" }}>
                To reschedule a booked session, you must provide a minimum notice period of 48 hours
                before the scheduled session time, as specified at the time of booking. This notice
                allows us to offer your time slot to other users and minimize disruption.
              </span>
            </Paragraph>

            <Paragraph>
              <span style={{ textDecoration: "underline" }}>Rescheduling Process:</span>
              <span style={{ marginLeft: "5px" }}>
                To request a reschedule, please please contact our customer support team through the
                platform or via email at contact@inforens.com
              </span>
            </Paragraph>
            <Paragraph>
              Once received, our team will review your request and respond with possible alternative
              time slots. Please note that rescheduling is subject to availability.
            </Paragraph>

            <Paragraph>
              <span style={{ textDecoration: "underline" }}>Limitations:</span>
              <span style={{ marginLeft: "5px" }}>
                Rescheduling requests made within the notice period may not be accommodated, and the
                original session time will remain in effect. If you fail to attend the session
                without providing the required notice, the session fee will not be refunded.
              </span>
            </Paragraph>

            <Paragraph style={{ marginBottom: "35px" }}>
              <span style={{ textDecoration: "underline" }}>Exceptional Circumstances:</span>
              <span style={{ marginLeft: "5px" }}>
                We understand that emergencies can occur. In such cases, please contact our support
                team directly, and we will do our best to assist you.
              </span>
            </Paragraph>

            <Title level={4}>Platform applicable law</Title>
            <Paragraph style={{ marginBottom: "35px" }}>
              By using this platform, you agree that the laws of the United Kingdom of Great Britain
              and the Northern Ireland (U.K.), without regard to principles of conflict laws, will
              govern these terms and conditions, or any dispute of any sort that might come between
              Inforens and you, or its business partners and associates.
            </Paragraph>

            <Title level={4}>Disputes</Title>
            <Paragraph style={{ marginBottom: "35px" }}>
              Any dispute related in any way to your use of this platform or to products and
              services you purchase from us shall be arbitrated by English Courts and you consent to
              exclusive jurisdiction and venue of such courts.
            </Paragraph>

            <Title level={4}>Indemnification</Title>
            <Paragraph style={{ marginBottom: "35px" }}>
              You agree to indemnify Inforens and its affiliates and hold Inforens harmless against
              legal claims and demands that may arise from your use or misuse of our services. We
              reserve the right to select our own legal counsel.
            </Paragraph>

            <Title level={4}>Disclaimers</Title>
            <Paragraph style={{ textDecoration: "underline" }}>
              Liability for User-Generated Content
            </Paragraph>
            <Paragraph>
              Inforens allows users to create and share content. We do not endorse, support,
              represent, or guarantee the completeness, truthfulness, accuracy, or reliability of
              any content posted by users. By using Inforens, you acknowledge that any reliance on
              user-generated content is at your own risk. We disclaim all liability for any content
              created or shared by users, including any errors or omissions, or any loss or damage
              incurred as a result of the use of any content made available through the platform.
            </Paragraph>
            <Paragraph style={{ textDecoration: "underline" }}>
              Limitation of Liability for Technical Issues
            </Paragraph>
            <Paragraph>
              Inforens platform services are provided on an "as is" and "as available" basis. We do
              not guarantee that the platform will be uninterrupted, timely, secure, or error-free.
              We disclaim all liability for any temporary service interruptions, bugs, or other
              technical problems that may affect the operation of the platform. To the fullest
              extent permitted by law, we will not be liable for any direct, indirect, incidental,
              special, consequential, or exemplary damages, including but not limited to damages for
              loss of profits, goodwill, use, data, or other intangible losses resulting from the
              use or inability to use the platform.
            </Paragraph>
            <Paragraph style={{ textDecoration: "underline" }}>
              Disclaimer of Professional Advice
            </Paragraph>
            <Paragraph style={{ marginBottom: "35px" }}>
              The content and services provided through Inforens are intended for informational
              purposes only and do not constitute professional advice (legal, medical, financial, or
              any other professional advice). We disclaim all liability for any actions taken or not
              taken based on the information or recommendations provided through the platform.
              Always seek the advice of a qualified professional (legal, medical, financial, or any
              other professional) with any questions you may have regarding any specific matter.
            </Paragraph>

            <Title level={4}>Limitation on liability</Title>
            <Paragraph>
              To the fullest extent permitted by law, Inforens and its affiliates, officers,
              employees, agents, partners, and licensors will not be liable for any indirect,
              incidental, special, consequential, or punitive damages, or any loss of profits or
              revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill,
              or other intangible losses, resulting from (i) your use or inability to use the
              platform; (ii) any unauthorized access to or use of our servers and/or any personal
              information stored therein; (iii) any bugs, viruses, trojan horses, or the like that
              may be transmitted to or through the platform by any third party; or (iv) any errors
              or omissions in any content or for any loss or damage incurred as a result of the use
              of any content posted, emailed, transmitted, or otherwise made available through the
              platform.
            </Paragraph>
            <Paragraph>
              Inforens is not liable for any damages that may occur to you as a result of your
              misuse of our platform.
            </Paragraph>
            <Paragraph style={{ marginBottom: "35px" }}>
              Inforens reserves the right to edit, modify, and change this Agreement at any time.
              Any changes will be effective immediately upon posting on our website and on the app.
              This Agreement is an understanding between Inforens and the user, and this supersedes
              and replaces all prior agreements regarding the use of this platform.
            </Paragraph>

            <Title level={4}>Contact Us</Title>
            <Paragraph>
              If you have any questions about these Terms and Conditions, you can contact us:
              <ul style={{ listStyleType: "disc", marginLeft: "20px", paddingLeft: "0" }}>
                <li style={{ position: "relative", marginBottom: "5px" }}>
                  By visiting this page on our website:
                  <a
                    href="https://www.inforens.com"
                    style={{ color: "blue", textDecoration: "underline", marginLeft: "5px" }}
                  >
                    www.inforens.com
                  </a>
                </li>
                <li style={{ position: "relative", marginBottom: "5px" }}>
                  By sending us an email:
                  <a
                    href="mailto:contact@inforens.com"
                    style={{ color: "blue", textDecoration: "underline", marginLeft: "5px" }}
                  >
                    contact@inforens.com
                  </a>
                </li>
              </ul>
            </Paragraph>
          </Space>
        </div>
      </GeneralCard>
    </div>
  );
};

export default TermsAndCondtion;
